export default "/packs/images/snow~961553ce7ad4995ea79eec21d07a6092.png";